var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendUp01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5C12.0397 5 11.6666 5.3731 11.6666 5.83333C11.6666 6.29357 12.0397 6.66667 12.5 6.66667H16.3215L11.1869 11.8013C11.0121 11.976 10.9161 12.0711 10.8418 12.1342L10.8333 12.1413L10.8249 12.1342C10.7506 12.0711 10.6545 11.976 10.4798 11.8013L8.17992 9.50142C8.03122 9.35269 7.88639 9.20783 7.75372 9.0952C7.60801 8.9715 7.4231 8.83853 7.18167 8.76008C6.84694 8.65132 6.48636 8.65132 6.15162 8.76008C5.91019 8.83853 5.72528 8.9715 5.57957 9.0952C5.44689 9.20783 5.30208 9.35268 5.15338 9.50141L1.07739 13.5774C0.751954 13.9028 0.751954 14.4305 1.07739 14.7559C1.40283 15.0814 1.93046 15.0814 2.2559 14.7559L6.31309 10.6987C6.48782 10.524 6.58389 10.4289 6.6582 10.3658L6.66665 10.3587L6.67509 10.3658C6.7494 10.4288 6.84547 10.524 7.0202 10.6987L9.32005 12.9986C9.46875 13.1473 9.61356 13.2922 9.74624 13.4048C9.89194 13.5285 10.0769 13.6615 10.3183 13.7399C10.653 13.8487 11.0136 13.8487 11.3483 13.7399C11.5898 13.6615 11.7747 13.5285 11.9204 13.4048C12.0531 13.2922 12.1979 13.1473 12.3466 12.9986L17.5 7.84518V11.6667C17.5 12.1269 17.8731 12.5 18.3333 12.5C18.7935 12.5 19.1666 12.1269 19.1666 11.6667V5.83333C19.1666 5.3731 18.7935 5 18.3333 5H12.5Z",
    fill: "#17E28C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp01);
export default __webpack_public_path__ + "static/media/trend-up-01.6febcce908ff6481a93abc10a5da7c23.svg";
export { ForwardRef as ReactComponent };